<a [href]="src" target="_blank"><img class="image-preview" [src]="src" alt="image preview" loading="lazy" /></a>
<i *ngIf="canBeRemoved" (click)="remove?.emit()" class="remove-button" i-bs name="x" width="12" height="12"></i>
